import {
	ReadonlyRefObject,
	useEffect,
	useState
} from "react";
import { registerSizeListener } from "client_legacy/ndaw/sizing";

export const useVisibilityObserver = <T extends HTMLElement>(ref: ReadonlyRefObject<T | null>) => {
	const [isVisible, setIsVisible] = useState<boolean>(false);

	useEffect(
		() => {
			const setElement: T | null = ref.current;
			if (!setElement) {
				return undefined;
			}

			let wasVisible: boolean = false;

			return registerSizeListener(
				setElement,
				(newSize) => {
					const isNowVisible: boolean = newSize.width > 0;
					if (isNowVisible !== wasVisible) {
						wasVisible = isNowVisible;
						setIsVisible(isNowVisible);
					}
				}
			);
		},
		[ref]
	);

	return isVisible;
};